// @ts-nocheck
import { Helmet } from 'react-helmet-async';
import VuiBreadcrumb from '../../../../../vodea/@vodea-ui/components/VuiBreadcrumb';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from '@hookstate/core/dist';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { InformationBaseModel, InformationInputs, informationSchema } from './validation';
import VuiSelect from '../../../../../vodea/@vodea-ui/components/Forms/VuiSelect';
import { AxiosError, AxiosResponse } from 'axios';
import { mapHookErrors, showToast } from '../../../../../vodea/utilities/helpers/global';
import useIsMounted from '../../../../../vodea/utilities/hooks/useIsMounted';
import { defaultStatusOptions } from '../../../../../constants';
import VuiActionForm from '../../../../../vodea/@vodea-ui/components/Forms/VuiActionForm';
import { formatFormData, formatSetValueForm } from '../../../../../vodea/utilities/helpers/form';
import SalesRepository from '../../../../../repositories/SalesRepository';

const SettingSalesForm = () => {
  const { t } = useTranslation();
  const isMounted = useIsMounted();
  const navigate = useNavigate();
  const { id } = useParams();

  const title = id ? t('Edit Sales') : t('Create Sales');

  useEffect(() => {
    if (id) {
      getData();
    }
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const getData = () => {
    SalesRepository.show(id)
      .then((response: AxiosResponse) => {
        const data = response.data.data;

        const formattedData = formatSetValueForm(InformationBaseModel, data);

        _.forEach(formattedData, (value, name) => {
          informationSetValue(name, value);
        });
      })
      .catch((e: AxiosError) => {
        showToast(e.message, 'error');
      });
  };

  const informationLoading = useState(false);
  const {
    register: informationRegister,
    handleSubmit: informationHandleSubmit,
    errors: informationErrors,
    control: informationControl,
    setError: informationSetError,
    setValue: informationSetValue
  } = useForm<InformationInputs>({
    resolver: yupResolver(informationSchema)
  });

  const onInformationSubmit = informationHandleSubmit(data => {
    informationLoading.set(true);

    const formData = formatFormData(data);

    if (id === undefined) {
      SalesRepository.create(formData)
        .then((response: AxiosResponse) => {
          showToast(response.data.message, 'success');

          navigate('/setting/sales');
        })
        .catch((e: AxiosError) => {
          if (isMounted.current && e?.response?.data?.errors) {
            const errors = mapHookErrors(e.response.data.errors);
            Object.keys(errors).forEach((key: any) => {
              informationSetError(key, errors[key]);
            });

            showToast(e.response.data.message, 'error');
          }

          informationLoading.set(false);
        });
    } else {
      SalesRepository.update(id, formData)
        .then((response: AxiosResponse) => {
          showToast(response.data.message, 'success');
          informationLoading.set(false);
        })
        .catch((e: AxiosError) => {
          if (isMounted.current && e?.response?.data?.errors) {
            const errors = mapHookErrors(e.response.data.errors);
            Object.keys(errors).forEach((key: any) => {
              informationSetError(key, errors[key]);
            });

            showToast(e.response.data.message, 'error');
          }

          informationLoading.set(false);
        });
    }
  });

  const breadcrumbList = [
    {
      label: t('Setting'),
      link: '/setting'
    },
    {
      label: t('Sales'),
      link: '/setting/sales'
    },
    {
      label: id ? id : t('Create'),
      link: '/setting/sales/create'
    }
  ];

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <VuiBreadcrumb list={breadcrumbList} />

      <div className={'page-header-component'}>
        <h3 className={'title'}>{title}</h3>
      </div>
      <div id={'product-section'}>
        <form className={'form-wrapper'} onSubmit={onInformationSubmit}>
          <div className={'default-page-layout'}>
            <div className={'information-section'}>
              <div className={'card-paper'}>
                <div className={'card-header'}>
                  <h6 className={'card-header-title'}>{t('Information')}</h6>
                </div>
                <div className={'card-content'}>
                  <div className='row'>
                    <div className={'col-md-12'}>
                      <div
                        className={clsx({
                          'form-group': true,
                          error: informationErrors.name
                        })}
                      >
                        <label className={'form-label'}>Name</label>
                        <input type='text' name='name' className='form-control' ref={informationRegister} />
                        <label className={'label-help'}>{informationErrors.name?.message}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={'visibility-section'}>
              <div className={'card-paper'}>
                <div className={'card-header'}>
                  <h6 className={'card-header-title'}>{t('Visibility')}</h6>
                </div>
                <div className={'card-content'}>
                  <div className={'col-md-12'}>
                    <div
                      className={clsx({
                        'form-group': true,
                        error: informationErrors.is_visible
                      })}
                    >
                      <label className={'form-label'}>Status</label>
                      <div className={'form-select-wrapper'}>
                        <Controller
                          name={'is_visible'}
                          control={informationControl}
                          defaultValue={defaultStatusOptions[0]}
                          render={props => (
                            <VuiSelect options={defaultStatusOptions} defaultValue={props.value} onChange={props.onChange} />
                          )}
                        />
                      </div>
                      <label className={'label-help'}>{_.get(informationErrors.is_visible, 'message')}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <VuiActionForm loading={informationLoading.get()} cancelLink={'/setting/sales'} />
        </form>
      </div>
    </>
  );
};

export default SettingSalesForm;
